import React from 'react';
import styled from 'styled-components';
import {useIntl} from 'react-intl';
import {Label} from '@forecast-it/design-system';
import {NovaStudioColor} from '../shared/novaStudioColors';

// The same bordered bar the variable library uses, so the two sections line up on the tab.
const Container = styled.div`
	border: 1px solid ${NovaStudioColor.border};
	border-radius: 6px;
	padding: 10px 16px;
`;

// The MCP tools section's collapsed header row. It has no list to open yet, so it renders the header
// alone rather than a control that expands to nothing.
export function NovaMcpTools(): JSX.Element {
	const {formatMessage} = useIntl();
	return (
		<Container data-cy="nova-mcp-tools" data-testid="nova-mcp-tools">
			<Label>{formatMessage({id: 'nova.mcpTools.title'})}</Label>
		</Container>
	);
}
